const CLASSIC_REGION_KEY = 'classic_region'
const REGIONS = ['MN', 'MT', 'MB']

const REGION_NAME = {
  MN: 'Miền Nam',
  MT: 'Miền Trung',
  MB: 'Miền Bắc',
}

export const classicRegionName = (region) => REGION_NAME[region] || REGION_NAME.MT

const normalizeRegion = (value) => {
  if (!value) {
    return ''
  }

  let text = String(value).trim()
  try {
    const parsed = JSON.parse(text)
    if (typeof parsed === 'string') {
      text = parsed
    }
  } catch (error) {
    text = text.replace(/^"|"$/g, '')
  }

  text = text.toUpperCase()
  return REGIONS.includes(text) ? text : ''
}

export const rememberClassicRegion = (region) => {
  const normalized = normalizeRegion(region)
  if (!normalized) {
    return
  }
  try {
    localStorage.setItem(CLASSIC_REGION_KEY, normalized)
  } catch (error) {
    // localStorage can be unavailable in private mode
  }
}

export const readClassicRegion = (search = '') => {
  const params = new URLSearchParams(search.startsWith('?') ? search.slice(1) : search)
  const fromQuery = normalizeRegion(params.get('region'))
  if (fromQuery) {
    return fromQuery
  }

  try {
    const stored = normalizeRegion(localStorage.getItem(CLASSIC_REGION_KEY))
    if (stored) {
      return stored
    }
  } catch (error) {
    // localStorage can be unavailable in private mode
  }

  return 'MN'
}
